import React from 'react';
import { I18n, Trans } from 'react-i18next';


export class Fruits extends React.Component {
  render() {
    
    return (
      <I18n ns="translations">
        {
          (t, { i18n }) => (
                <section id="fruit-section">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 col-xs-12">
                        <div className="head-part">
                          <h1>{t('fruittitle')}</h1>
                          <p>{t('fruithead')}</p>
                        </div>
                      </div>
                      <div className="col-md-12 col-xs-12">
                        <div className="fruit-desc-part">
                          <h3>{t('fruittitle1')}</h3>
                          <p>{t('fruitpara1')}<span className="res-block">{t('fruitline1')}</span> {t('fruitpara2')} </p>
                        </div>
                      </div>

                 

                      <div className="col-md-12 col-xs-12">
                        <div className="picto-fruits">
                          <div className="picto-fruit-col">
                            <img src="images/picto_fruit_1.png"/>
                            <h4>{t('fruitimg1')}</h4>
                          </div>
                          <div className="picto-fruit-col">
                            <img src="images/picto_fruit_2.png"/>
                            <h4>{t('fruitimg2')}</h4>
                          </div>          
                          <div className="picto-fruit-col">
                            <img src="images/picto_fruit_3.png"/>
                            <h4>{t('fruitimg3')}</h4>
                          </div>
                          <div className="picto-fruit-col">
                            <img src="images/picto_fruit_4.png"/>
                            <h4>{t('fruitimg4')}</h4>
                          </div>
                          <div className="picto-fruit-col">
                            <img src="images/picto_fruit_5.png"/>
                            <h4>{t('fruitimg5')}</h4>
                          </div>
                          <div className="picto-fruit-col">
                            <img src="images/picto_fruit_6.png"/>
                            <h4>{t('fruitimg6')}</h4>
                          </div>
                          <div className="picto-fruit-col">
                            <img src="images/picto_fruit_7.png"/>
                            <h4>{t('fruitimg7')}</h4>
                          </div>
                          <div className="picto-fruit-col">
                            <img src="images/picto_fruit_8.png"/>
                            <h4>{t('fruitimg8')}</h4>
                          </div>
                          <div className="picto-fruit-col">
                            <img src="images/picto_fruit_9.png"/>
                            <h4>{t('fruitimg9')}</h4>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 col-xs-12 ">
                        <div className="footer-content">
                          <h1>14 115</h1>
                          <p>{t('fruitfooter')}.</p>
                        </div>          
                      </div>
                    </div>
                  </div>
                </section>
              )
            }
      </I18n>
     )
   }
 }


// WEBPACK FOOTER //
// ./src/components/Propos/Fruits/Fruits.js